module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921082651_T.2dfe5fa5.jpg";